import { useQuery } from '@tanstack/react-query';
import { Eye } from 'lucide-react';
import { supabase } from '@/integrations/supabase/client';
import { getRecentlyViewed } from '@/lib/recentlyViewed';
import { PropertyScrollRow } from './PropertyScrollRow';

export function ViewedPropertiesRow() {
  const ids = getRecentlyViewed();

  const { data: properties } = useQuery({
    queryKey: ['landing-viewed', ids.join(',')],
    enabled: ids.length > 0,
    queryFn: async () => {
      const { data } = await supabase
        .from('properties')
        .select('*, property_images(url, is_primary)')
        .in('id', ids);
      // preserve recency order
      const map = new Map((data || []).map((p: any) => [p.id, p]));
      return ids.map(id => map.get(id)).filter(Boolean);
    },
  });

  if (!ids.length || !properties?.length) return null;
  return <PropertyScrollRow title="Viewed Properties" icon={<Eye className="h-5 w-5 text-primary" />} properties={properties} />;
}
